var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYouTubeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    rx: 17.5,
    fill: "#F40000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.85468 23.6747C9.51145 23.5732 9.19828 23.3925 8.94159 23.148C8.6849 22.9035 8.49223 22.6023 8.37983 22.2698C7.73756 20.5514 7.54725 13.3761 8.78422 11.9596C9.19591 11.4988 9.77716 11.2151 10.4018 11.17C13.7202 10.8217 23.9728 10.8682 25.1503 11.2861C25.4815 11.391 25.7841 11.5677 26.0354 11.803C26.2867 12.0382 26.4802 12.326 26.6014 12.6446C27.3031 14.421 27.3269 20.8765 26.5062 22.5833C26.2885 23.0276 25.924 23.3875 25.4714 23.605C24.2345 24.2088 11.496 24.1972 9.85468 23.6747ZM15.1237 20.3076L21.0707 17.2889L15.1237 14.2469V20.3076Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouTubeIcon);
export default __webpack_public_path__ + "static/media/YouTubeIcon.3d9b0ca525f657ec8e1268937ff4faec.svg";
export { ForwardRef as ReactComponent };